export default "__VITE_ASSET__CmJdq8VN__";